(function () {
  'use strict';

  var N8N_WEBHOOK_URL = 'https://moldarte-n8n.f5puiw.easypanel.host/webhook/65a6ccfe-6f52-4d0c-a739-9ae32d10dc7a';
  var URL_REGEX = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i;
  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PHONE_ALLOWED_CHARS_REGEX = /^\+?[0-9()\s-]+$/;
  var PHONE_EXTENSION_REGEX = /(?:ext\.?|int\.?|interno)\s*\d+$/i;
  var PHONE_MIN_DIGITS = 8;
  var PHONE_MAX_DIGITS = 15;
  var MIN_TEXTAREA_LENGTH = 8;
  var STICKY_HEADER_SELECTORS = [
    '[data-sticky-header]',
    '.shopify-section-header-sticky',
    '.shopify-section-header',
    'header.site-header',
    '.site-header',
    '#shopify-section-header'
  ];

  function initMoldarteMoldRequestWidget(container) {
    if (!container || container.dataset.moldarteMoldRequestInitialized === 'true') return;

    var form = container.querySelector('[data-moldarte-mold-request-form]');
    if (!form) return;

    var status = container.querySelector('[data-moldarte-mold-request-status]');
    var submitButton = form.querySelector('[type="submit"]');
    var emailField = form.elements.email;
    var phoneField = form.elements.phone;
    var notifyField = form.elements.notify_me;
    var fieldWraps = Array.prototype.slice.call(form.querySelectorAll('[data-mold-request-field]'));
    var fields = fieldWraps
      .map(function (fieldWrap) {
        return fieldWrap.querySelector('input, select, textarea');
      })
      .filter(Boolean);

    function getTrimmedValue(input) {
      return input && input.value ? input.value.replace(/^\s+|\s+$/g, '') : '';
    }

    function getStickyOffset() {
      return STICKY_HEADER_SELECTORS.reduce(function (largestHeight, selector) {
        var node = document.querySelector(selector);
        if (!node) return largestHeight;

        var computedStyle = window.getComputedStyle(node);
        var isSticky = computedStyle.position === 'sticky' || computedStyle.position === 'fixed';
        if (!isSticky) return largestHeight;

        return Math.max(largestHeight, node.getBoundingClientRect().height);
      }, 0);
    }

    function getScrollParent(node) {
      var current = node && node.parentElement;

      while (current && current !== document.body) {
        var style = window.getComputedStyle(current);
        var overflowY = style.overflowY;
        var isScrollable = /(auto|scroll|overlay)/.test(overflowY) && current.scrollHeight > current.clientHeight;
        if (isScrollable) return current;
        current = current.parentElement;
      }

      return window;
    }

    function scrollIntoViewIfNeeded(target) {
      if (!target || typeof target.getBoundingClientRect !== 'function') return;

      window.requestAnimationFrame(function () {
        var scrollParent = getScrollParent(target);
        var stickyOffset = getStickyOffset() + 16;
        var rect = target.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        if (scrollParent === window) {
          var topLimit = stickyOffset;
          var bottomLimit = viewportHeight - 16;
          var isVisible = rect.top >= topLimit && rect.bottom <= bottomLimit;

          if (!isVisible) {
            var windowTarget = window.pageYOffset + rect.top - stickyOffset;
            window.scrollTo({ top: Math.max(windowTarget, 0), behavior: 'smooth' });
          }

          return;
        }

        var parentRect = scrollParent.getBoundingClientRect();
        var parentTopLimit = parentRect.top + 12;
        var parentBottomLimit = parentRect.bottom - 12;
        var isInsideParent = rect.top >= parentTopLimit && rect.bottom <= parentBottomLimit;

        if (!isInsideParent) {
          var nextScrollTop = scrollParent.scrollTop + (rect.top - parentRect.top) - 12;
          scrollParent.scrollTo({ top: Math.max(nextScrollTop, 0), behavior: 'smooth' });
        }
      });
    }

    function setStatus(type, message) {
      if (!status) return;
      status.className = 'moldarte-mold-request__status is-visible moldarte-mold-request__status--' + type;
      status.textContent = message;
      scrollIntoViewIfNeeded(status);
    }

    function clearStatus() {
      if (!status) return;
      status.className = 'moldarte-mold-request__status';
      status.textContent = '';
    }

    function getFieldWrap(input) {
      return input ? input.closest('[data-mold-request-field]') : null;
    }

    function ensureErrorNode(input, field) {
      var errorNode = field ? field.querySelector('[data-mold-request-error]') : null;
      if (!errorNode) return null;

      if (!errorNode.id) {
        errorNode.id = (input.id || input.name || 'moldarte-mold-request-field') + '-error';
      }

      errorNode.setAttribute('aria-live', 'polite');
      return errorNode;
    }

    function setFieldDescribedBy(input, errorNode, helperNode) {
      var describedBy = [];
      if (helperNode && helperNode.id) describedBy.push(helperNode.id);
      if (errorNode && errorNode.textContent) describedBy.push(errorNode.id);

      if (describedBy.length) {
        input.setAttribute('aria-describedby', describedBy.join(' '));
      } else {
        input.removeAttribute('aria-describedby');
      }
    }

    function setFieldError(input, message) {
      var field = getFieldWrap(input);
      if (!field) return;

      var errorNode = ensureErrorNode(input, field);
      var helperNode = field.querySelector('.moldarte-mold-request__helper');

      field.classList.add('has-error');
      input.setAttribute('aria-invalid', 'true');

      if (errorNode) {
        errorNode.textContent = message;
      }

      setFieldDescribedBy(input, errorNode, helperNode);
    }

    function clearFieldError(input) {
      var field = getFieldWrap(input);
      if (!field) return;

      var errorNode = ensureErrorNode(input, field);
      var helperNode = field.querySelector('.moldarte-mold-request__helper');

      field.classList.remove('has-error');
      input.removeAttribute('aria-invalid');

      if (errorNode) {
        errorNode.textContent = '';
      }

      setFieldDescribedBy(input, errorNode, helperNode);
    }

    function getPhoneValidationMessage(value) {
      var normalizedValue = value.replace(PHONE_EXTENSION_REGEX, '').replace(/^\s+|\s+$/g, '');
      var digitsOnly = normalizedValue.replace(/\D/g, '');

      if (!PHONE_ALLOWED_CHARS_REGEX.test(normalizedValue)) {
        return 'Ingresá un teléfono o WhatsApp válido. Podés usar números, espacios, paréntesis, + o guiones.';
      }

      if (digitsOnly.length < PHONE_MIN_DIGITS) {
        return 'Ingresá un teléfono o WhatsApp válido con al menos ' + PHONE_MIN_DIGITS + ' números.';
      }

      if (digitsOnly.length > PHONE_MAX_DIGITS) {
        return 'Ingresá un teléfono o WhatsApp válido con no más de ' + PHONE_MAX_DIGITS + ' números.';
      }

      if (/^0+$/.test(digitsOnly)) {
        return 'Ingresá un teléfono o WhatsApp válido.';
      }

      return '';
    }

    function validateField(input) {
      if (!input || input.disabled) {
        if (input) clearFieldError(input);
        return true;
      }

      var value = getTrimmedValue(input);
      var label = input.getAttribute('data-label') || 'Este campo';
      var isRequired = input.hasAttribute('required');
      var type = input.getAttribute('data-validate') || input.getAttribute('type') || input.tagName.toLowerCase();
      var validity = input.validity || {};

      clearFieldError(input);

      if (input.type === 'checkbox') return true;

      if (isRequired && !value) {
        setFieldError(input, label + ' es obligatorio.');
        return false;
      }

      if (!value) return true;

      if (type === 'email' && (validity.typeMismatch || !EMAIL_REGEX.test(value))) {
        setFieldError(input, 'Ingresá un email válido, por ejemplo nombre@correo.com.');
        return false;
      }

      if (type === 'phone') {
        var phoneMessage = getPhoneValidationMessage(value);
        if (phoneMessage) {
          setFieldError(input, phoneMessage);
          return false;
        }
      }

      if (type === 'url' && !URL_REGEX.test(value)) {
        setFieldError(input, 'Ingresá un link válido, por ejemplo https://ejemplo.com.');
        return false;
      }

      if (input.tagName.toLowerCase() === 'textarea' && isRequired && value.length < MIN_TEXTAREA_LENGTH) {
        setFieldError(input, 'Sumá un poco más de detalle así podemos evaluar mejor tu pedido.');
        return false;
      }

      return true;
    }

    function validateContactFields() {
      var emailValid = validateField(emailField);
      var phoneValue = getTrimmedValue(phoneField);
      var phoneValid = !phoneValue || validateField(phoneField);

      return emailValid && phoneValid;
    }

    function validateForm() {
      var isValid = true;

      fields.forEach(function (field) {
        if (field.type === 'checkbox' || field === emailField || field === phoneField) return;
        if (!validateField(field)) isValid = false;
      });

      if (!validateContactFields()) isValid = false;

      return isValid;
    }

    function buildPayload() {
      return {
        tipo_de_formulario: 'pedido_de_molde_producto',
        molde_producto_buscado: getTrimmedValue(form.elements.mold_name),
        detalle: getTrimmedValue(form.elements.details),
        uso_previsto: form.elements.usage.value || '',
        tamano_aproximado: getTrimmedValue(form.elements.approx_size),
        cantidad_referencia: getTrimmedValue(form.elements.quantity_reference),
        link_o_referencia: getTrimmedValue(form.elements.reference_link),
        nombre_contacto: getTrimmedValue(form.elements.contact_name),
        email: getTrimmedValue(emailField),
        telefono_whatsapp: getTrimmedValue(phoneField),
        quiere_aviso: notifyField && notifyField.checked ? 'Sí' : 'No',
        page_url: window.location.href,
        page_title: document.title,
        timestamp: new Date().toISOString(),
        source: 'moldarte-mold-request-widget'
      };
    }

    function resetFormState() {
      form.classList.remove('is-submitting');
      if (submitButton) submitButton.disabled = false;
    }

    fieldWraps.forEach(function (fieldWrap) {
      var field = fieldWrap.querySelector('input, select, textarea');
      var helperNode = fieldWrap.querySelector('.moldarte-mold-request__helper');

      if (!field) return;

      if (helperNode && !helperNode.id) {
        helperNode.id = (field.id || field.name || 'moldarte-mold-request-field') + '-helper';
      }

      ensureErrorNode(field, fieldWrap);
      clearFieldError(field);

      field.addEventListener('blur', function () {
        if (field === emailField || field === phoneField) {
          validateContactFields();
          return;
        }
        validateField(field);
      });

      field.addEventListener('input', function () {
        if (field === emailField || field === phoneField) {
          if (getFieldWrap(emailField).classList.contains('has-error') || getFieldWrap(phoneField).classList.contains('has-error')) {
            validateContactFields();
          }
          return;
        }

        if (fieldWrap.classList.contains('has-error')) {
          validateField(field);
        }
      });

      field.addEventListener('change', function () {
        if (field === emailField || field === phoneField) {
          validateContactFields();
          return;
        }

        if (fieldWrap.classList.contains('has-error') || field.tagName.toLowerCase() === 'select') {
          validateField(field);
        }
      });
    });

    if (notifyField) {
      notifyField.addEventListener('change', function () {
        if (getTrimmedValue(emailField) || getTrimmedValue(phoneField) || notifyField.checked) {
          validateContactFields();
        }
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearStatus();

      if (form.classList.contains('is-submitting')) return;

      if (!validateForm()) {
        setStatus('error', 'Revisá los campos marcados así nos llega bien tu pedido de molde/producto.');

        var firstInvalid = form.querySelector('[aria-invalid="true"]');
        if (firstInvalid) {
          firstInvalid.focus({ preventScroll: true });
          scrollIntoViewIfNeeded(firstInvalid);
        }
        return;
      }

      if (!N8N_WEBHOOK_URL || N8N_WEBHOOK_URL.indexOf('YOUR-N8N-WEBHOOK-URL-HERE') !== -1) {
        setStatus('error', 'Antes de publicar el formulario necesitás reemplazar la URL del webhook de n8n.');
        return;
      }

      form.classList.add('is-submitting');
      if (submitButton) submitButton.disabled = true;
      setStatus('success', 'Enviando tu pedido…');

      window.fetch(N8N_WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(buildPayload())
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Webhook response was not successful');
          }

          setStatus('success', '¡Gracias! Recibimos tu pedido y lo vamos a tener en cuenta para evaluar nuevos ingresos.');
          form.reset();
          fields.forEach(clearFieldError);
        })
        .catch(function () {
          setStatus('error', 'No pudimos enviar tu pedido en este momento. Probá de nuevo en unos minutos.');
        })
        .finally(function () {
          resetFormState();
        });
    });

    container.dataset.moldarteMoldRequestInitialized = 'true';
  }

  window.initMoldarteMoldRequestWidget = initMoldarteMoldRequestWidget;

  document.addEventListener('DOMContentLoaded', function () {
    var widgets = document.querySelectorAll('[data-moldarte-mold-request-widget]');
    Array.prototype.forEach.call(widgets, initMoldarteMoldRequestWidget);
  });
})();
